import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export interface GenerateCreditCardTokenLinkResponse {
  url: string;
  sessionId: string;
  transactionId: string;
  confirmationId: string;
}

export const generateCreditCardTokenLinkOperation = async (
  userId: number,
  setLoading: (loading: boolean) => void,
): Promise<GenerateCreditCardTokenLinkResponse | null> => {
  try {
    setLoading(true);
    const res = await appApi.generateCreditCardTokenLink(userId);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return null;
    }

    setLoading(false);
    return res.data.body;
  } catch (e) {
    console.error('Error generating credit card token link:', e);
    toast.error('שגיאה ביצירת קישור להוספת כרטיס אשראי');
    setLoading(false);
    return null;
  }
};
